var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"fas fa-bell-slash"}),_vm._v(" 公告 ")]),_c('div',{staticClass:"text-muted font-mini"},[_vm._v(" 无公告 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }